import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorFrequencyDistributionChart from "./DonorFrequencyDistributionChart";

// Static data for donor frequency distribution (annual)
const STATIC_FREQUENCY_DATA = {
  oneTime: 450,
  twoTimes: 320,
  threeTimes: 180,
  fourTimes: 95,
  fivePlusTimes: 55,
};

const DonorFrequencyDistributionWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donor Frequency Distribution (Annual)")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorFrequencyDistributionChart data={STATIC_FREQUENCY_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorFrequencyDistributionWrapper;
